import React, { useState, Dispatch, SetStateAction, useContext } from "react";
import { Button, Label /*, Badge */ } from "reactstrap";

import UserContext from "../contexts/user";
import EventContext from "../contexts/event";
import getEncodedImageUrl from "../helpers/get-encoded-image";
import { useIntl } from "react-intl";

import Footer from "./footer";
import FilterDropdown from "./filter-dropdowns";
import { EslidesEvent, Aggregates, Presentation } from "../types/presentation";
import { FormattedMessage } from "react-intl";
import { useHistory, useParams } from "react-router-dom";
import MyPresentations from "../containers/my-presentations";
import fil from "date-fns/esm/locale/fil/index.js";
import leftArrow from '../containers/Synopsis/Assets/Icons/LeftArrow.svg'
import line from '../containers/Synopsis/Assets/Icons/line.svg'

const formatDate = (dateInput: string | Date) => {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
};

const SidebarMain: React.FC<{
  event: EslidesEvent;
  aggregates: Aggregates;
  filter: {
    speakers: Array<string>;
    rooms: Array<string>;
    associations: Array<string>;
    dates: Array<string>;
    activeQuizzesOnly: boolean;
  };
  setFilter: Dispatch<SetStateAction<any>>;
  openProfileModal: boolean;
  setOpenProfileModal: (arg0: any) => void;
  setSchedule?: string;
  presentations?: Presentation[];
}> = ({
  event,
  aggregates,
  filter,
  setFilter,
  setOpenProfileModal,
  openProfileModal,
  setSchedule,
  presentations,
}) => {
    const { event_slug } = useParams<{
      event_slug: string;
    }>();
    let history = useHistory();

    const [profile, setProfile] = useState(setSchedule);
    const [collapsed, setCollapsed] = useState(false);
    const userContext = useContext(UserContext);
    const eventContext = useContext(EventContext);
    console.log(userContext.user?.is_speaker);

    console.log("userContext.user", userContext.user);
    const intl = useIntl();

    const [showFilters, setShowFilters] = useState(false);
    const toggleFilters = () => {
      setShowFilters(!showFilters);
    };
    // why this name is speaker if ther is both type of user
    //  this one related to Presentation data from postgres

    // aggergate data coming for speaker related to presentation list
    const { speakers, rooms, associations, dates } = aggregates;
    console.log(speakers, "speakers");

    const allSpeakers = speakers
      .sort((a, b) => a.firstName.localeCompare(b.firstName))
      .map((speaker) => ({
        label: `${speaker.title ? `${speaker.title} ` : ""}${speaker.firstName} ${speaker.lastName
          }`,
        value: speaker._id,
      }));
    const allRooms = rooms
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((room) => ({ label: room.name, value: room._id }));
    const allAssosiations = associations
      .filter((f) => f)
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((association) => ({
        label: association.name,
        value: association._id,
      }));
    const allDates = dates
      .sort((a, b) => a.localeCompare(b))
      .map((date) => ({ label: date, value: date }));

    console.log(
      "--------------------------------------------- userContext.user",
      userContext
    );
    const slug = document.location.pathname.split("/")[1] || "invalid";
    let token: any = localStorage.getItem(`token-${slug}`);

    function hasWhiteSpace(s: string) {
      return (/\s/).test(s);
    }

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const isMobile = window.innerWidth <= 991;
console.log(window.innerWidth, "window.innerWidth");

    // Helper to render nav buttons in a given order
    const renderNavButtons = (order: string[]) => {
      return order.map((item) => {
        switch (item) {
          case "schedule":
            return (
              <Button
                key="schedule"
                className={`nav-link scroll-item ${profile === "schedule" ? "active" : ""}`}
                onClick={() => {
                  setProfile("schedule");
                  history.push("/" + event_slug);
                }}
              >
                {profile === "schedule" && <span className="rectangular-box" />}
                {profile === "schedule" && <span className="profile-navbar-bottom" />}
                <img src="/icons/schedule-ico.svg" alt="schedule" />
                {!isSidebarCollapsed && (
                  <span className="text">
                    <FormattedMessage id="menu.schedule" />
                  </span>
                )}
              </Button>
            );
          case "synopsis":
            return userContext.user && (
              <Button
                key="synopsis"
                className={`nav-link ${profile === "synopsis" ? "active" : ""}`}
                onClick={() => {
                  setProfile("synopsis");
                  setFilter({ ...filter, activeQuizzesOnly: false });
                  history.push("/" + event_slug + "/synopsis");
                }}
              >
                {profile === "synopsis" && <span className="rectangular-box" />}
                {profile === "synopsis" && <span className="profile-navbar-bottom" />}
                <img src="/icons/Synopsis-Icon.svg" alt="synopsis" />
                {!isSidebarCollapsed && (
                  <span className="text">
                    <FormattedMessage id="menu.synopsis" />
                  </span>
                )}
              </Button>
            );
          case "my-pres":
            return userContext.user?.is_speaker && (
              <Button
                key="my-pres"
                className={`nav-link ${profile === "my-pres" ? "active" : ""}`}
                onClick={() => {
                  setProfile("my-pres");
                  history.push("/" + event_slug + "/my-presentations");
                }}
              >
                {profile === "my-pres" && <span className="rectangular-box" />}
                {profile === "my-pres" && <span className="profile-navbar-bottom" />}
                <img src="/icons/my-presentations-ico.svg" alt="presentations" />
                {!isSidebarCollapsed && (
                  <span className="text">
                    <FormattedMessage id="menu.presentations" />
                  </span>
                )}
              </Button>
            );
          case "my-schedule":
            return userContext.user && (
              <Button
                key="my-schedule"
                className={`nav-link ${profile === "my-schedule" ? "active" : ""}`}
                onClick={() => {
                  setProfile("my-schedule");
                  setFilter({ ...filter, activeQuizzesOnly: false });
                  history.push("/" + event_slug + "/my-schedule");
                }}
              >
                {profile === "my-schedule" && <span className="rectangular-box" />}
                {profile === "my-schedule" && <span className="profile-navbar-bottom" />}
                <img src="/icons/my-schedule-ico.svg" alt="My Schedule" />
                {!isSidebarCollapsed && (
                  <span className="text">
                    <FormattedMessage id="menu.my-schedule" />
                  </span>
                )}
              </Button>
            );
          case "profile":
            return userContext.user && (
              <Button
                key="profile"
                className={`nav-link-schedule ${profile === "profile" ? "active" : ""}`}
                onClick={() => {
                  setProfile("profile");
                  setOpenProfileModal(!openProfileModal);
                }}
              >
                {profile === "profile" && <span className="rectangular-box" />}
                {profile === "profile" && <span className="profile-navbar-bottom" />}
                <img src="/icons/profile-ico.svg" className="rounded" alt="Profile" />
              </Button>
            );
          case "logout":
            return userContext.user && (
              <Button
                key="logout"
                className={`nav-link ${profile === "logout" ? "active" : ""}`}
                onClick={() => {
                  setProfile("logout");
                  userContext.setOneTimeShowLogin(true);
                  userContext.setListUser(JSON.stringify({ id: "", token: "" }));
                }}
              >
                <img src="/images/logout_new.png" alt="Logout" height={28} width={28} />
                {!isSidebarCollapsed && (
                  <span className="text">
                    <FormattedMessage id="menu.logout" />
                  </span>
                )}
              </Button>
            );
          case "login":
            return !userContext.user && (
              <Button
                key="login"
                className="nav-link"
                onClick={() => {
                  setProfile("login");
                  userContext.setShowLogin(true);
                }}
              >
                <img src="/icons/profile-ico.svg" alt="Login" />
                {!isSidebarCollapsed && (
                  <span className="text">
                    <FormattedMessage id="menu.login" />
                  </span>
                )}
              </Button>
            );
          default:
            return null;
        }
      });
    };

    return (
      <>
        <div className={`sidebar curve ${isSidebarCollapsed ? "collapsed" : ""}`}>
          <div className="sidebar-main mobile-height ">
            {/* Collapse Toggle Button */}
            {window.innerWidth > 991 && (
              <img
              src={leftArrow}
              alt="Toggle"
              width={20}
              height={20}
              onClick={() => {
                setIsSidebarCollapsed(!isSidebarCollapsed);
                // Add collapsed class to parent grid container
                const gridContainer = document.querySelector('.grid-contianer');
                if (gridContainer) {
                  if (!isSidebarCollapsed) {
                    gridContainer.classList.add('sidebar-collapsed');
                  } else {
                    gridContainer.classList.remove('sidebar-collapsed');
                  }
                }
              }}
              className="sidebar-toggle-btn tw-cursor-pointer"
              />
            )}

            {/* Logo */}
            <div className="logo-container ">
              <div className="d-flex align-items-center justify-content-center " style={{ height: window.innerWidth > 991 ? "100%" : "50%" }}>
                <div className="image d-flex flex-column align-items-center">
                  {event.logo ? (
                    <img
                      height={60}
                      src={getEncodedImageUrl(event.logo, 110, 100, "contain")}
                      alt="logo"
                    />
                  ) : (
                    <div className="logo_image">
                      <img src="/images/logo-default.png" alt="logo" />
                    </div>
                  )}
                  {!isSidebarCollapsed && (
                    <>
                      <span className="mb-0" style={{ marginTop: window.innerWidth > 991 ? "2rem" : '5px', color: '#32363F', fontWeight: 400, fontSize: '16px' }}>
                        {/* {hasWhiteSpace(event.name) ? event.name : event.name.length > 15 ? event.name.substring(0, 15) + '...' : event.name} */}
                        {event.name}
                      </span>
                      <span
                        className="mt-3"
                        style={{
                          marginTop: "2rem",
                          wordSpacing: "5px",
                          fontWeight: 400,
                          color: '#32363F'
                        }}
                      >
                        {formatDate(event.start)} - {formatDate(event.end)}
                        <img src={line} alt="" className="px-2 mb-1"/>
                        {event.venue}
                      </span>
                    </>
                  )}
                </div>
              </div>
              {/* {!isSidebarCollapsed && <div className="schedule-text mob-menu">SCHEDULE</div>} */}
            </div>

            {/* Nav Links */}
            <div className={`nav-conatiner scroll-row  ${userContext.user ? "" : "mob_nav_margin"}`}>
              <div className={`nav-container-box-scroll ${userContext.user ? "" : "mob_contents"}`}>
                <div className={`nav-container-box ${userContext.user ? "" : "mob_nav_top_border"}`}>
                  {isMobile
                    ? renderNavButtons([
                        "schedule",
                        "synopsis",
                        "my-pres",
                        "my-schedule",
                        "profile",
                        "logout",
                        "login"
                      ])
                    : (
                      <>
                        {userContext.user && (
                          <Button
                            className={`nav-link-schedule ${profile === "profile" ? "active" : ""}`}
                            onClick={() => {
                              setProfile("profile");
                              setOpenProfileModal(!openProfileModal);
                            }}
                          >
                            {profile === "profile" && <span className="rectangular-box" />}
                            {profile === "profile" && <span className="profile-navbar-bottom" />}
                            <img src="/icons/profile-ico.svg" className="rounded" alt="Profile" />
                          </Button>
                        )}
                        <Button
                          className={`nav-link scroll-item ${profile === "schedule" ? "active" : ""}`}
                          onClick={() => {
                            setProfile("schedule");
                            history.push("/" + event_slug);
                          }}
                        >
                          {profile === "schedule" && <span className="rectangular-box" />}
                          {profile === "schedule" && <span className="profile-navbar-bottom" />}
                          <img src="/icons/schedule-ico.svg" alt="schedule" />
                          {!isSidebarCollapsed && (
                            <span className="text">
                              <FormattedMessage id="menu.schedule" />
                            </span>
                          )}
                        </Button>
                        {userContext.user && (
                          <>
                            <Button
                              className={`nav-link ${profile === "synopsis" ? "active" : ""}`}
                              onClick={() => {
                                setProfile("synopsis");
                                setFilter({ ...filter, activeQuizzesOnly: false });
                                history.push("/" + event_slug + "/synopsis");
                              }}
                            >
                              {profile === "synopsis" && <span className="rectangular-box" />}
                              {profile === "synopsis" && <span className="profile-navbar-bottom" />}
                              <img src="/icons/Synopsis-Icon.svg" alt="synopsis" />
                              {!isSidebarCollapsed && (
                                <span className="text">
                                  <FormattedMessage id="menu.synopsis" />
                                </span>
                              )}
                            </Button>
                            <Button
                              className={`nav-link ${profile === "my-schedule" ? "active" : ""}`}
                              onClick={() => {
                                setProfile("my-schedule");
                                setFilter({ ...filter, activeQuizzesOnly: false });
                                history.push("/" + event_slug + "/my-schedule");
                              }}
                            >
                              {profile === "my-schedule" && <span className="rectangular-box" />}
                              {profile === "my-schedule" && <span className="profile-navbar-bottom" />}
                              <img src="/icons/my-schedule-ico.svg" alt="My Schedule" />
                              {!isSidebarCollapsed && (
                                <span className="text">
                                  <FormattedMessage id="menu.my-schedule" />
                                </span>
                              )}
                            </Button>
                          </>
                        )}
                        {userContext.user?.is_speaker && (
                          <Button
                            className={`nav-link ${profile === "my-pres" ? "active" : ""}`}
                            onClick={() => {
                              setProfile("my-pres");
                              history.push("/" + event_slug + "/my-presentations");
                            }}
                          >
                            {profile === "my-pres" && <span className="rectangular-box" />}
                            {profile === "my-pres" && <span className="profile-navbar-bottom" />}
                            <img src="/icons/my-presentations-ico.svg" alt="presentations" />
                            {!isSidebarCollapsed && (
                              <span className="text">
                                <FormattedMessage id="menu.presentations" />
                              </span>
                            )}
                          </Button>
                        )}
                        {userContext.user ? (
                          <>
                            <Button
                              className="nav-link-desktop"
                              onClick={() => {
                                setProfile("profile");
                                setOpenProfileModal(!openProfileModal);
                              }}
                            >
                              <img src="/icons/profile-ico.svg" alt="PROFILE" />
                              {!isSidebarCollapsed && (
                                <span className="text">
                                  <FormattedMessage id="menu.profile" />
                                </span>
                              )}
                            </Button>
                            <Button
                              className={`nav-link ${profile === "logout" ? "active" : ""}`}
                              onClick={() => {
                                setProfile("logout");
                                userContext.setOneTimeShowLogin(true);
                                userContext.setListUser(JSON.stringify({ id: "", token: "" }));
                              }}
                            >
                              <img src="/images/logout_new.png" alt="Logout" height={28} width={28} />
                              {!isSidebarCollapsed && (
                                <span className="text">
                                  <FormattedMessage id="menu.logout" />
                                </span>
                              )}
                            </Button>
                          </>
                        ) : (
                          <Button
                            className="nav-link"
                            onClick={() => {
                              setProfile("login");
                              userContext.setShowLogin(true);
                            }}
                          >
                            <img src="/icons/profile-ico.svg" alt="Login" />
                            {!isSidebarCollapsed && (
                              <span className="text">
                                <FormattedMessage id="menu.login" />
                              </span>
                            )}
                          </Button>
                        )}
                      </>
                    )}
                </div>
              </div>
            </div>

            {/* Advertisement */}
            <div className="ad-container" dangerouslySetInnerHTML={{ __html: event.ad }}></div>
          </div>
        </div>
      </>

      // mobile implementation
    );
  };

export default SidebarMain;
